<template>
    <div class="salarii-wrapper">
        <div class="salarii-row sal-top-1">
            <div class="left-block">
                <label class="lbl ml-1">Data:</label>
                <DxSelectBox :items="luni" v-model="dataSelectata" display-expr="text" value-expr="value" width="220"
                    @value-changed="getAngajati" />
                <DxSelectBox :items="ani" v-model="anulSelectat" display-expr="text" value-expr="value" width="220"
                    @value-changed="getAngajati" />
            </div>
        </div>
        <div class="salarii-row sal-top-1">
            <label class="lbl ml-1">Angajati:</label>
            <DxRadioGroup :items="['Activi', 'Inactivi', 'Schimbare Loc Munca']" layout="horizontal"
                v-model="modPreluare" @value-changed="onModeChanged" />
        </div>
        <div :class="{ 'disabled-grid': modPreluare === 'Companie' }">
            <DxDataGrid class="salarii-grid" :data-source="dsEmployees" key-expr="Id" :show-borders="true"
                :show-row-lines="true"  :allow-column-reordering="true"
                :allow-column-resizing="true" :column-resizing-mode="'nextColumn'" :hover-state-enabled="true"
                :focused-row-index="0" :column-auto-width="false" width="100%" @selection-changed="onSelectionChanged"
                :onInitNewRow="onInitNewRow">
                <DxSelection mode="single" />
                <DxFilterRow :visible="true" />
                <DxSorting mode="multiple" />
                <DxPaging :page-size="14" />
                <DxSearchPanel :visible="false" :search-visible-columns-only="true" />
                <DxColumn data-field="InternalCode" caption="Cod" width="80" />
                <DxColumn data-field="Cnp" caption="CNP" />
                <DxColumn caption="Nume Prenume" :calculate-cell-value="calculateFullName"
                    :calculate-filter-expression="calculateFilterExpression" :min-width="150" :allow-search="true" />
                <DxColumn data-field="StructId" caption="Departament">
                    <DxLookup :data-source="dsDepartamente" display-expr="Name" value-expr="ID" />
                </DxColumn>
                <DxToolbar>
                    <DxItem>
                        <template #default>
                            <DxButton icon="add" type="success" @click="onAddClick" />
                        </template>
                    </DxItem>
                </DxToolbar>
            </DxDataGrid>
            <DxPopupAdd :visible="addPopupVisible" :show-title="true" :height="570" :width="840">
                <template #title>
                    <div
                        style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                        Adăugare
                    </div>
                </template>
                <DxForm :col-count="1" :form-data="formData" label-alignment="center">
                    <DxTabbedItem :tab-panel-options="tabPanelOptions" css-class="tabs-two-rows">
                        <DxTab :title="tabs[0]">
                            <DxGroupItem :col-count="3">
                                <DxSimpleItem data-field="InternalCode" :label="{ text: 'Cod intern' }" :editor-options="{
                                    placeholder: '#AUTO',
                                    elementAttr: { class: 'internal-code-ph' }
                                }" :is-required="true" />
                                <DxSimpleItem data-field="Name" :label="{ text: 'Nume' }" :is-required="true" />
                                <DxSimpleItem data-field="Surname" :label="{ text: 'Prenume' }" :is-required="true" />
                                <DxSimpleItem data-field="Cnp" :label="{ text: 'CNP' }" :is-required="true"
                                    editor-type="dxTextBox" :editor-options="{
                                        mask: '0000000000000',
                                        useMaskedValue: true,
                                        onValueChanged: onCnpChanged
                                    }" />

                                <DxSimpleItem data-field="Sex" :label="{ text: 'Sex' }" editor-type="dxSelectBox"
                                    :editor-options="{
                                        dataSource: dsGetAll?.Sex ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    }" :is-required="true" />
                                <DxSimpleItem data-field="BornDate" editor-type="dxDateBox"
                                    :label="{ text: 'Data Nașterii' }"
                                    :editor-options="{ displayFormat: 'dd MMM yyyy' }" :is-required="true" />
                                <DxSimpleItem data-field="EmpgroupId" :label="{ text: 'Grup Angajati' }"
                                    editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGrupuri,
                                        valueExpr: 'ID',
                                        displayExpr: 'Nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    }" :is-required="true" />

                                <DxSimpleItem data-field="StructId" :label="{ text: 'Departament' }" :col-span="2"
                                    editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsDepartamente,
                                        valueExpr: 'ID',
                                        displayExpr: 'Name',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează',
                                        readOnly: !isCnpValid
                                    }" :is-required="true" />
                            </DxGroupItem>
                        </DxTab>
                        <DxTab :title="tabs[1]">
                            <DxGroupItem :col-count="3">
                                <DxSimpleItem data-field="DocIdentTip" :label="{ text: 'Tip Act Identitate' }"
                                    editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGetAll?.DocIdentTip ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Carte Identitate'
                                    }" />
                                <DxSimpleItem data-field="DocIdentSerie" :label="{ text: 'Serie' }" />
                                <DxSimpleItem data-field="DocIdentNo" :label="{ text: 'Numar' }" editor-type="dxTextBox"
                                    :editor-options="{
                                        mask: '000000',
                                        useMaskedValue: true,

                                    }" />
                                <DxSimpleItem data-field="DocIdentIssuer" :label="{ text: 'Emitent' }" />
                                <DxSimpleItem data-field="DocIdentIssueDate" editor-type="dxDateBox"
                                    :label="{ text: 'Data Emiterii' }" :editor-options="{
                                        displayFormat: 'dd MMM yyyy',
                                        onValueChanged(e) {
                                            formData.DocIdentIssueDate = e.value;
                                        }
                                    }" />

                                <DxSimpleItem data-field="DocIdentExpiryDate" editor-type="dxDateBox"
                                    :label="{ text: 'Data Expirare' }" :editor-options="{
                                        displayFormat: 'dd MMM yyyy',
                                        min: expiryMinDate
                                    }" />

                                <DxSimpleItem :label="{ text: 'Țara' }" editor-type="dxSelectBox" :editor-options="{
                                    dataSource: dsTari ?? [],
                                    valueExpr: 'ID',
                                    displayExpr: 'Nume',
                                    showClearButton: true,
                                    searchEnabled: true,
                                    placeholder: 'Selectează',
                                    value: formData.BornCntryId,
                                    onValueChanged(e) {
                                        formData.BornCntryId = e.value;
                                    }
                                }" />

                                <DxSimpleItem :label="{ text: 'Localitate' }" editor-type="dxSelectBox" :editor-options="{
                                    dataSource: dsLocalitati,
                                    valueExpr: 'ID',
                                    displayExpr(item) { return item ? `${item.CodSiruta}/Jud. ${item.Judet}/ ${item.Localitate}/ ${item.Sat}` : `` },
                                    showClearButton: true,
                                    searchEnabled: true,
                                    placeholder: 'Selectează',
                                    value: formData.BornPlaceId,
                                    onValueChanged(e) {
                                        formData.BornPlaceId = e.value;
                                    }
                                }" :col-span="2" />

                                <DxSimpleItem :col-span="3" :label="{ text: 'Adresa Domiciliu' }"
                                    editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsAdrese,
                                        valueExpr: 'ID',
                                        displayExpr: 'Adresa1',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează',

                                        value: formData.AddressId,

                                        onValueChanged: (e) => {
                                            formData.AddressId = e.value;
                                        },

                                        onOpened: (e) => {
                                            e.component.close();
                                            popupAdreseVisible = true;
                                        }
                                    }" />


                            </DxGroupItem>
                        </DxTab>
                        <DxTab :title="tabs[2]">
                            <DxGroupItem :col-count="3">
                                <DxSimpleItem :label="{ text: 'Meserie/Profesie' }" editor-type="dxSelectBox"
                                    :editor-options="{
                                        dataSource: dsMeserii,
                                        valueExpr: 'ID',
                                        displayExpr(item) { return item ? `${item.code}/${item.name}` : `` },
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează',
                                        value: formData.MeserieId,
                                        onValueChanged(e) {
                                            formData.MeserieId = e.value;
                                        }
                                    }" />

                                <DxSimpleItem data-field="NrCrtOrg" :label="{ text: 'Nr. Crt. Organigrama' }" />
                                <DxSimpleItem :label="{ text: 'Funcție (Post)' }" editor-type="dxSelectBox"
                                    :editor-options="{
                                        dataSource: dsPositions,
                                        valueExpr: 'ID',
                                        displayExpr: 'name',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează',
                                        value: formData.PositionId,
                                        onValueChanged(e) {
                                            formData.PositionId = e.value;
                                        }
                                    }" />
                                <DxSimpleItem data-field="WorkGrade" :label="{ text: 'Grupa de Muncă' }"
                                    editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGetAll?.WorkGrade ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    }" />
                                <DxSimpleItem data-field="FunctieDeBaza" editor-type="dxSwitch"
                                    :label="{ text: 'Funcție de bază' }" />
                                <DxSimpleItem data-field="Pensionar" :label="{ text: 'Este Pensionar? ' }"
                                    editor-type="dxSwitch" />
                                <DxSimpleItem data-field="OreContract" :label="{ text: 'Ore Contract' }" />
                                <DxSimpleItem data-field="ZileConc" :label="{ text: 'Zile Concediu' }" />
                                <DxSimpleItem data-field="StudiesLevel" :label="{ text: 'Nivel Studii' }"
                                    editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGetAll?.StudiesLevel ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    }" />
                                <DxSimpleItem data-field="MrtStatus" :label="{ text: 'Stare Civila' }"
                                    editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGetAll?.Mrt ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    }" />
                                <DxSimpleItem data-field="DrvLicense" :label="{ text: 'Permis Auto' }"
                                    editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGetAll?.DrvLicense ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: '[fără]'
                                    }" />
                                <DxSimpleItem data-field="Vechime" :label="{ text: 'Vechime Calculat' }"
                                    :editor-options="{ readOnly: true, placeholder: '#AUTO' }" />
                                <DxSimpleItem data-field="Observations" :label="{ text: 'Observatii' }" :col-span="3" />
                            </DxGroupItem>
                        </DxTab>
                        <DxTab :title="tabs[3]">
                            <DxGroupItem :col-count="2">

                                <DxSimpleItem data-field="TransferInRevisal" editor-type="dxSwitch"
                                    :label="{ text: 'Transfer In Revisal' }" />
                                <DxSimpleItem data-field="Apatrid"  editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGetAll?.Apatrid ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        
                                    }" />
                                <DxSimpleItem :label="{ text: 'Nationalitate' }" editor-type="dxSelectBox"
                                    :editor-options="{
                                        dataSource: dsNationalitate,
                                        valueExpr: 'ID',
                                        displayExpr: 'Nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'România',
                                        value: formData.TaraNationalitateId,
                                        onValueChanged(e) {
                                            formData.TaraNationalitateId = e.value;
                                        }
                                    }" />

                                <DxSimpleItem data-field="Mentiuni" :label="{ text: 'Mentiuni' }" />
                            </DxGroupItem>
                        </DxTab>
                        <DxTab :title="tabs[4]" :disabled="detaliiStrainDisabled">
                            <DxGroupItem :col-count="2">
                                <DxSimpleItem data-field="TipAutorizatie" :label="{ text: 'Tip Autorizatie' }"
                                    :col-span="2" editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGetAll?.TipAutorizatie ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează'
                                    }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" editor-type="dxDateBox"
                                    :label="{ text: 'Data Inceput Autorizatie' }" :editor-options="{
                                        displayFormat: 'dd MMM yyyy',
                                        readOnly: isReadonlyTipAuorizatie,
                                        onValueChanged(e) {
                                            formData.DataInceputAutorizatie = e.value;
                                        }
                                    }" />

                                <DxSimpleItem data-field="DataSfarsitAutorizatie" editor-type="dxDateBox"
                                    :label="{ text: 'Data Sfarsit Autorizatie' }" :editor-options="{
                                        displayFormat: 'dd MMM yyyy',
                                        min: expiryDate,
                                        readOnly: isReadonlyTipAuorizatie,
                                    }" />
                            </DxGroupItem>
                        </DxTab>

                        <DxTab :title="tabs[5]">
                            <DxGroupItem :col-count="2">
                                <DxSimpleItem data-field="CasaSn" :label="{ text: 'Casa Asigurari Sanatate' }"  editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGetAll?.CasaSn ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                       
                                    }" />
                                <DxSimpleItem data-field="D112TipAsigurat" :label="{ text: 'Tip Asigurat(A, B)' }"
                                    editor-type="dxSelectBox" :editor-options="{
                                        dataSource: dsGetAll?.D112_TipAsigurat ?? [],
                                        valueExpr: 'cod',
                                        displayExpr: 'nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Salariat'
                                    }" />
                                <DxSimpleItem data-field="D112AsigScu" editor-type="dxSelectBox" :editor-options="{
                                    dataSource: dsGetAll?.D112_AsigScu ?? [],
                                    valueExpr: 'cod',
                                    displayExpr: 'nume',
                                    showClearButton: true,
                                    searchEnabled: true,
                                    placeholder: 'Fără scutire'
                                }" :label="{ text: 'Scutire plata impozit pe venit: tip persoana' }" :col-span="2" />
                                <DxSimpleItem data-field="D112AsigCi" editor-type="dxSwitch"
                                    :label="{ text: 'Asigurat pentru concedii si indemnizatii de asigurari sociale de sanatate' }"
                                    :col-span="2" />
                                <DxSimpleItem data-field="D112AsigSo" editor-type="dxSwitch"
                                    :label="{ text: 'Asigurat in sistemul de asigurari pt somaj' }" />

                                <DxSimpleItem data-field="D112AsigExc" editor-type="dxSwitch"
                                    :label="{ text: 'Persoana exceptatat de la plata CAS si CASS' }" />
                            </DxGroupItem>
                        </DxTab>
                        <DxTab :title="tabs[6]">
                            <DxGroupItem :col-count="2">

                                <DxSimpleItem data-field="CardSalary" :label="{ text: 'Are Card?' }"
                                    editor-type="dxSwitch" />

                                <DxSimpleItem data-field="CardNo" :label="{ text: 'Numar' }" :editor-options="{
                                    mask: '0000000000000000',
                                    useMaskedValue: true,
                                    readOnly: isReadonly
                                }" />
                                <DxSimpleItem :label="{ text: 'Banca' }" editor-type="dxSelectBox" :editor-options="{
                                    dataSource: dsBanci,
                                    valueExpr: 'ID',
                                    displayExpr: 'Nume',
                                    showClearButton: true,
                                    searchEnabled: true,
                                    placeholder: 'Selectează',
                                    value: formData.CardBankId,
                                    onValueChanged(e) {
                                        formData.CardBankId = e.value;
                                    },

                                }" />
                                <DxSimpleItem data-field="CardAccNo" :label="{ text: 'Cont' }" />
                            </DxGroupItem>
                        </DxTab>
                        <DxTab :title="tabs[7]">
                            <DxGroupItem :col-count="3">
                                <DxSimpleItem data-field="PontajOraInceput" :label="{ text: 'Oră început program' }" />
                                <DxSimpleItem data-field="PontajPauzaMinute"
                                    :label="{ text: 'Durată pauză de masă (minute)' }" />
                                <DxSimpleItem  :label="{ text: 'Vizibil pentru: ' }" editor-type="dxSelectBox"
                                    :editor-options="{
                                        dataSource: dsStructura,
                                        valueExpr: 'Id',
                                        displayExpr: 'Nume',
                                        showClearButton: true,
                                        searchEnabled: true,
                                        placeholder: 'Selectează',
                                        value: formData.StructuraId,
                                        onValueChanged(e) {
                                            formData.StructuraId = e.value;
                                        }
                                    }" />
                                <DxSimpleItem data-field="PontajUsrId" editor-type="dxTextBox" :label="{ text: 'User ID - Sistem Pontaj' }"
                                    :col-span="3" />

                            </DxGroupItem>
                        </DxTab>
                        <DxTab :title="tabs[8]">
                            <DxGroupItem :col-count="2">
                                <DxSimpleItem data-field="SalBaza" :label="{ text: 'Salariu de baza' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie"
                                    :label="{ text: 'Somer unic sustinator fam. monoparentala' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie"
                                    :label="{ text: 'Somer peste 45 ani ' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie"
                                    :label="{ text: 'Avans suma fixa ' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie"
                                    :label="{ text: 'Primeste bonuri de masa' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie"
                                    :label="{ text: 'Suma Spor Weekend' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie"
                                    :label="{ text: 'Calcul Contributii CAS, CASS la Sal Min' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie"
                                    :label="{ text: 'Motiv exceptare CAS, CASS Sal Min' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: 'Numar copii inscrisi invatamant(OG.16/2022-art.77.10b)-deducere supl.' }" />

                            </DxGroupItem>
                        </DxTab>
                        <DxTab :title="tabs[9]">
                            <DxGroupItem :col-count="2">
                                <DxSimpleItem data-field="salBaza" :label="{ text: 'Conventie Grupare' }"
                                    :col-span="2" />
                                <DxSimpleItem data-field="DataInceputAutorizatie"
                                    :label="{ text: 'Conventie Somaj Data ' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: 'Conventie Somaj Nr ' }" />
                            </DxGroupItem>
                        </DxTab>
                        <DxTab :title="tabs[10]" css-class="tab-venituri">
                            <DxGroupItem :col-count="1">
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.0 Alte drepturi neimpozitabile, cf.art.76 alin.(4) din CF (necategorisite mai jos)****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.1 Indemnizatii de delegare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF***' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.2 Indemnizatii de detasare neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.3 Indemnizatii specifice detasarii transnationale neimpozitabile, cf.art.76 alin.(4) lit.h) din CF****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.4 Prestatii suplimentare primite de salariati in baza clauzei de mobilitate neimpozabile, cf.art.76 alin.(2) si alin.(4) lit.a) din CF	****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.5 Avantajele sub forma dreptului la stock options plan, la momentul acordarii si la momentul exercitarii acestora, cf.art.76 alin.(4) lit.r) din CF	****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.6 Contributiile la un fond de pensii facultative(L.204/2006), suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76alin.(4^1) lit.e) din CF	****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.7 Primele de asigurare voluntara de sanatate precum si serviciile medicale furnizate sub forma de abonament, suportate de angajator pentru angajatii proprii, in limita a 400 euro/an/persoana, cf.art.76 alin.(4^1) lit.f) din CF	****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.8 C/val serv. turistice si/sau de tratament (+transportul), pe perioada CO, acordate de angajator pentru salariatii proprii, cf. CIM sau in regulamentul intern, cf.art.76 alin.(4^1) lit.d) din CF	****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.9 C/val ab. pentru utilizarea facilitatilor sportive, suportate de angajator, in limita a 400 euro/an/persoana, cf.art. 76 alin. 4^1 lit. h) din CF	****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.10 C/val hranei acordate de catre angajator pentru angajatii proprii, cf. art. 76 alin. 4^1 lit. b) din CF	****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.11 Cazarea si contravaloarea chiriei pentru spatiile de cazare/de locuit puse de catre angajatori la dispozitia angajatilor propriii, cf. art.76 alin. 4^1 lit. c) din CF	****' }" />
                                <DxSimpleItem data-field="DataInceputAutorizatie" :col-span="2"
                                    :label="{ text: ' 8.4.12 Sumele acordate angajatilor care desfasoara activitati in regim de telemunca, cf. art. 76 alin.4^1 lit. g) din CF		****' }" />
                            </DxGroupItem>
                        </DxTab>
                    </DxTabbedItem>

                </DxForm>
                <DxToolbarItem toolbar="bottom" location="after" :widget="'dxButton'" :options="{
                    text: 'Salvează',
                    type: 'success',
                    stylingMode: 'contained',
                    onClick: submitForm,
                    width: 110,
                    height: 32
                }" />

                <DxToolbarItem toolbar="bottom" location="after" :widget="'dxButton'" :options="{
                    text: 'Închide',
                    type: 'danger',
                    stylingMode: 'contained',
                    onClick: closePopup,
                    width: 110,
                    height: 32
                }" />
            </DxPopupAdd>

            <DxPopupAdd :visible="popupAdreseVisible" :show-title="true" title="Selectare adresa" :width="840"
                :height="680" @hiding="popupAdreseVisible = false">
                <template #title>
                    <div
                        style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                        Selectează adresa
                    </div>
                </template>
                <div style="padding: 15px">

                    <div style="margin-bottom: 20px;">
                        <h4
                            style="font-weight: 800; margin-bottom: 10px; border-bottom: 2px solid #ff2c21; padding-bottom: 6px; color: #ff2c21;">
                            Adresa
                        </h4>

                        <DxSelectBox :data-source="dsGetAll?.TipAdresa" display-expr="nume" value-expr="cod"
                            placeholder="Tip" :search-enabled="true" v-model:value="dataAdress.TipCod" />


                        <div style="display: flex; gap: 10px; margin-top: 10px;">

                            <DxTextBox placeholder="Strada" style="margin-top: 10px; flex: 2;"
                                v-model:value="dataAdress.Strada" />

                            <DxTextBox placeholder="StradaNr" style="margin-top: 10px; flex: 1;"
                                v-model:value="dataAdress.StradaNr" />

                            <DxTextBox placeholder="Bloc" style="margin-top: 10px; flex: 1;"
                                v-model:value="dataAdress.Bloc" />

                            <DxTextBox placeholder="Scara" style="margin-top: 10px; flex: 1;"
                                v-model:value="dataAdress.Scara" />

                            <DxTextBox placeholder="Etaj" style="margin-top: 10px; flex: 1;"
                                v-model:value="dataAdress.Etaj" />

                            <DxTextBox placeholder="Apartament" style="margin-top: 10px; flex: 2;"
                                v-model:value="dataAdress.Apartament" />

                            <DxTextBox placeholder="CodPostal" style="margin-top: 10px; flex: 2;"
                                v-model:value="dataAdress.CodPostal" />

                        </div>


                        <div style="display: flex; gap: 10px; margin-top: 10px;">

                            <DxSelectBox :data-source="dsTari" display-expr="Nume" value-expr="ID" placeholder="Țara"
                                :search-enabled="true" v-model:value="dataAdress.TaraID"
                                @value-changed="onTaraChanged" />

                            <DxSelectBox :data-source="dsJudete" display-expr="Nume" value-expr="ID" placeholder="Județ"
                                :search-enabled="true" v-model:value="dataAdress.JudetID"
                                @value-changed="onJudetChanged" :disabled="!dataAdress.TaraID" />

                            <DxSelectBox :data-source="dsLocalitati" display-expr="Localitate" value-expr="ID"
                                placeholder="Localitate" :search-enabled="true" v-model:value="localitateId"
                                @value-changed="onLocalitateChanged" :disabled="!dataAdress.JudetID" />

                            <DxSelectBox :data-source="dsLocalitati" display-expr="Sat" value-expr="ID"
                                placeholder="Sat" :search-enabled="true" v-model:value="satId"
                                @value-changed="onSatChanged" :disabled="!localitateId" />
                        </div>

                        <DxTextBox placeholder="Cod SIRUTA" style="margin-top: 10px" :value="codSiruta"
                            :read-only="true" />


                    </div>

                    <div style="margin-bottom: 20px;">
                        <h4
                            style="font-weight: 800; margin-bottom: 10px; border-bottom: 2px solid #ff2c21; padding-bottom: 6px; color: #ff2c21;">
                            Profesional
                        </h4>

                        <DxTextBox placeholder="Telefon" v-model:value="dataAdress.Telefon" :show-spin-buttons="false"
                            :show-clear-button="true" :min="0" :format="'#0'" />

                        <DxTextBox placeholder="Email (acces Portal HR)" style="margin-top: 10px"
                            v-model:value="dataAdress.Email" />
                    </div>

                    <div style="margin-bottom: 20px;">
                        <h4
                            style="font-weight: 800; margin-bottom: 10px; border-bottom: 2px solid #ff2c21; padding-bottom: 6px; color: #ff2c21;">
                            Personal
                        </h4>

                        <DxTextBox placeholder="Telefon" v-model:value="dataAdress.TelefonPersonal"
                            :show-spin-buttons="false" :show-clear-button="true" :min="0" :format="'#0'" />

                        <DxTextBox placeholder="Email" style="margin-top: 10px"
                            v-model:value="dataAdress.EmailPersonal" />
                    </div>

                     <div style="text-align: right; margin-top: 15px;">
                        <DxButton text="Aplică" type="default"
                            style="height: 32px; font-size: 13px; padding: 2px 10px; width:110px; margin-right: 10px;"
                            @click="applyAddress" />

                        <DxButton text="Închide" type="danger"
                            style="height: 32px; font-size: 13px; padding: 2px 10px; width:110px;"
                            @click="closePopupAdrese" />
                    </div>

                </div>


            </DxPopupAdd>
        </div>
    </div>
</template>


<script lang="ts">
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxForm, DxSimpleItem, DxGroupItem, DxTabbedItem, DxTab } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import { defineComponent, isReadonly } from 'vue';
import {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxSelection,
    DxSorting,
    DxPaging,
    DxLookup,
    DxItem,
    DxToolbar,
    DxSearchPanel
} from 'devextreme-vue/data-grid';
import DxAccordion, { DxItem as DxItemAccordion } from "devextreme-vue/accordion";
import DxButton from 'devextreme-vue/button';
import DxSelectBox from 'devextreme-vue/select-box';
import DxCheckBox from 'devextreme-vue/check-box';
import DxRadioGroup from 'devextreme-vue/radio-group';
import PER_ActiveEmployees from '@/services/PER/PER_ActiveEmployees';
import PER_Employees from '@/services/PER/PER_Employees';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { DxNumberBox, DxTextBox } from 'devextreme-vue';
export default defineComponent({
    name: 'SalariiGridLikeOldWinform',
    components: {
        DxDataGrid,
        DxColumn,
        DxFilterRow,
        DxSelection,
        DxSorting,
        DxPaging,
        DxButton,
        DxSelectBox,
        DxCheckBox,
        DxRadioGroup,
        DxLookup,
        DxPopupAdd,
        DxForm,
        DxSimpleItem,
        DxItem,
        DxToolbar,
        DxToolbarItem,
        DxGroupItem,
        DxTabbedItem,
        DxTab,
        DxSearchPanel,
        DxItemAccordion,
        DxAccordion,
        DxTextBox,
        DxNumberBox
    },
    data() {
        return {
            isCnpValid: false,
            dsLocalitati: {} as DataSource,
            dsMeserii: {} as DataSource,
            dsTari: {} as DataSource,
            dsAdrese: {} as DataSource,
            dsPositions: {} as DataSource,
            dsNationalitate: {} as DataSource,
            dsStructura: {} as DataSource,
            dsBanci: {} as DataSource,
            dsGrupuri: {} as DataSource,
            dsJudete: {} as DataSource,
            dsDepartamente: [],
            modPreluare: 'Angajati',
            nationalitateRomaniaId: '0a2ed359-3731-47a2-855b-9ee58b1cbc32',
            departamentSelectat: null,
            dsEmployees: [],
            dataSelectata: new Date().getMonth() + 1,
            anulSelectat: new Date().getFullYear(),
            addPopupVisible: false,
            popupAdreseVisible: false,
            dataAdress: {
                LocalitateID: null,
                JudetID: null,
                Telefon: null,
                Email: null,
                TaraID: null,
                LocalitateCodSiruta: null,
                TipCod: null,
                Strada: '',
                StradaNr: '',
                Bloc: '',
                Scara: '',
                Etaj: '',
                Apartament: '',
                CodPostal: '',
                PartenerID: null,       // îl setezi când deschizi popup-ul
                EmailPersonal: null,
                TelefonPersonal: null
            },
            taraId: null,
            judetId: null,
            localitateId: null,
            codSiruta: null,
            satId: null,
            dsStrazi: [],
            formData: {
                //Id: null,
                //OldId: null,
                //BornJudetId: "",
                Name: "",
                Surname: "",
                Descr: "",
                BornCntryId: null,
                BornPlace: "",
                BornDate: null,
                Cnp: "",
                InternalCode: "",
                DocIdentSerie: "",
                DocIdentNo: "",
                DocIdentIssuer: "",
                DocIdentIssueDate: null,
                Sex: "",
                MrtStatus: "",
                Handicap: "",
                CardSalary: false,
                CardAccNo: "",
                CardNo: "",
                DrvLicense: "",
                StudiesLevel: "",
                Vechime: null,
                SalBaza: null,
                OreContract: 8,
                WorkGrade: "",
                AddressId: null,
                PositionId: null,
                ProbationDate: null,
                ProbationPeriod: false,
                Student: false,
                StudentYear: null,
                EmpgroupId: null,
                ZileConc: 20,
                StructId: null,
                MeserieId: null,
                Sters: false,
                PontajSchemaId: null,
                CardBankId: null,
                IsSindicat: false,
                SporConditii: null,
                NaturaAngajat: false,
                SporPermanent: false,
                DataModificare: null,
                BornPlaceId: null,
                Foto: null,
                CasaSn: "",
                DataExpiraContract: null,
                Pensionar: false,
                FunctieDeBaza: true,
                DataStartVechime: null,
                Apatrid: "",
                CnpVechi: "",
                DetaliiSalariatStrain: "",
                Mentiuni: "",
                DocIdentTip: "CarteIdentitate",
                TaraNationalitateId: "0a2ed359-3731-47a2-855b-9ee58b1cbc32",
                TipAutorizatie: "",
                DataInceputAutorizatie: null,
                DataSfarsitAutorizatie: null,
                TransferInRevisal: false,
                UserCreareRevisal: "",
                DataCreareRevisal: null,
                UserModificareRevisal: "",
                DataModificareRevisal: null,
                DocIdentExpiryDate: null,
                DataStartVechimeFirma: null,
                StructuraId: null,
                AccesCardId: null,
                Observations: "",
                NrCrtOrg: "",
                PontajUsrId: null,
                Foto2: null,
                D112AsigCi: false,
                D112AsigSo: false,
                D112AsigScu: null,
                D112AsigExc: false,
                PontajOraInceput: null,
                PontajPauzaMinute: null,
                D112TipAsigurat: "1",
                SemnaturaImg: null
            },
            dsGetAll: {
                Sex: [],
                DocIdentTip: [],
                Mrt: [],
                DrvLicense: [],
                WorkGrade: [],
                StudiesLevel: [],
                D112_TipAsigurat: [],
                D112_AsigScu: [],
                loc: [],
                tari: [],
                adrese: [],
                meserii: [],
                functie: [],
                nationalitati: [],
                structura: [],
                TipAutorizatie: [],
                TipAdresa: [],
                Apatrid: [],
                CasaSn:[]

            },
            luni: [
                { text: 'Ianuarie', value: 1 },
                { text: 'Februarie', value: 2 },
                { text: 'Martie', value: 3 },
                { text: 'Aprilie', value: 4 },
                { text: 'Mai', value: 5 },
                { text: 'Iunie', value: 6 },
                { text: 'Iulie', value: 7 },
                { text: 'August', value: 8 },
                { text: 'Septembrie', value: 9 },
                { text: 'Octombrie', value: 10 },
                { text: 'Noiembrie', value: 11 },
                { text: 'Decembrie', value: 12 },
            ],
            ani: [
                { text: '2010', value: 2010 },
                { text: '2011', value: 2011 },
                { text: '2012', value: 2012 },
                { text: '2013', value: 2013 },
                { text: '2014', value: 2014 },
                { text: '2015', value: 2015 },
                { text: '2016', value: 2016 },
                { text: '2017', value: 2017 },
                { text: '2018', value: 2018 },
                { text: '2019', value: 2019 },
                { text: '2020', value: 2020 },
                { text: '2021', value: 2021 },
                { text: '2022', value: 2022 },
                { text: '2023', value: 2023 },
                { text: '2024', value: 2024 },
                { text: '2025', value: 2025 },
                { text: '2026', value: 2026 },
            ],
            selectedTab: 0,
            tabs: [
                "Identificare",
                "Act Identitate",
                "Diverse",
                "Revisal",
                "Detalii Străin",
                "D112",
                "Card",
                "Pontaj",
                "Categorie: Bază",
                "Categorie: Șomaj",
                "Venituri neimpozitabile"
            ],
        };
    },
    mounted() {
        this.getAngajati();
        this.getDepartamente();
        this.getAll();

        this.dsMeserii = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `PER_Meserii`,
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
            sort: [{ selector: 'name', desc: false }]
        })
        this.dsTari = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + 'ERP_Tari',
                key: 'ID',
                keyType: 'Guid',
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
                    };
                }
            },
            sort: [{ selector: 'Nume', desc: false }]

        });

        this.dsJudete = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + 'ERP_Judete',
                key: 'ID',
                keyType: 'Guid',
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
                    };
                }
            }

        });
        this.dsLocalitati = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + 'ERP_Localitati',
                key: 'ID',
                keyType: 'Guid',
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
                    };
                }
            }
        });

        this.dsAdrese = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `ERP_Adrese`,
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
        })
        this.dsPositions = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `PER_Positions`,
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
        })
        this.dsNationalitate = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `RU_RVS_Nationalitati`,
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
        })
        this.dsStructura = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `ERP_StructuraCompanie`,
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
        })

        this.dsBanci = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `ERP_Banci`,
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
        })
        this.dsGrupuri = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `RU_GrupuriAngajati`,
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
        })
    },
    emits: ['selection-changed'],
    computed: {
        isCard: {
            get() {
                return this.formData.CardSalary;
            },
            set(val) {
                this.formData.CardSalary = val;
            }
        },
        expiryMinDate() {
            return this.formData.DocIdentIssueDate || null;

        },
        expiryDate() {

            return this.formData.DataInceputAutorizatie || null;
        },
        detaliiStrainDisabled() {

            return !this.formData.TaraNationalitateId
                || this.formData.TaraNationalitateId === this.nationalitateRomaniaId;
        },

        isReadonly() {
            return !this.formData.CardSalary;
        },
        isReadonlyTipAuorizatie() {
            return !this.formData.TipAutorizatie;
        },
        tabPanelOptions(): Record<string, unknown> {
            return {
                selectedIndex: this.selectedTab,
                deferRendering: true,
                animationEnabled: false,
                showNavButtons: false,

                onSelectionChanged: (e: any) => {
                    this.selectedTab = e.component.option("selectedIndex");
                }
            };
        },
        filteredJudete() {
            if (!this.taraId) return [];
            return this.dsJudete.filter(j => j.TaraID === this.taraId);
        },
        filteredLocalitati() {
            if (!this.judetId) return [];
            return this.dsLocalitati.filter(l => l.JudetID === this.judetId);
        }



    },
    methods: {
        getAngajati() {
            const { startDate, endDate } = this.getIntervalLuna(this.anulSelectat, this.lunaSelectata);

            PER_Employees
                .get()
                .then((response: any) => {
                    this.dsEmployees = response.data;
                    console.log(this.dsEmployees)
                })
                .catch((e: Error) => console.log(e));
        },
        getAll() {
            PER_Employees.getAll()
                .then((response: any) => {
                    this.dsGetAll = {
                        ...this.dsGetAll,
                        ...response.data
                    };
                })
                .catch((e: Error) => console.log(e));
        },
        getIntervalLuna(an: number, luna: number) {
            const startDate = new Date(an, luna - 1, 1, 0, 0, 0);
            const endDate = new Date(an, luna, 0, 23, 59, 59, 999);
            return { startDate, endDate };
        },
        applyAddress() {
            const a = this.dataAdress;

            const adresa1 = [
                a.Strada ? `Str. ${a.Strada}` : null,
                a.StradaNr ? `${a.StradaNr}` : null,
                a.Bloc ? `Bl. ${a.Bloc}` : null,
                a.Scara ? `Sc. ${a.Scara}` : null,
                a.Etaj ? `Et. ${a.Etaj}` : null,
                a.Apartament ? `Ap. ${a.Apartament}` : null,
                a.CodPostal ? `CP ${a.CodPostal}` : null
            ]
                .filter(x => x !== null)
                .join(', ');

            const body = {
                ...a,
                Adresa1: adresa1,
                Adresa2: null
            };

            PER_Employees.saveAdrese(body)
                .then((response) => {
                    const saved = response?.data ?? response;

                    const newId = saved.id || saved.ID;

                    if (!newId) {
                        console.error('Nu am primit ID-ul noii adrese din API.', saved);
                    }

                    this.popupAdreseVisible = false;

                    if (this.dsAdrese && typeof this.dsAdrese.reload === 'function') {
                        this.dsAdrese.reload().then(() => {
                            this.formData.AddressId = newId;
                        });
                    } else if (this.dsAdrese && typeof this.dsAdrese.load === 'function') {
                        this.dsAdrese.load().then(() => {
                            this.formData.AddressId = newId;
                        });
                    } else {
                        this.formData.AddressId = newId;
                    }

                    notify('Adresa a fost salvată cu succes.', 'success', 3000);
                })
                .catch((error) => {
                    let msg = 'A apărut o eroare la salvare.';
                    if (error.response && error.response.data) {
                        msg = error.response.data.message
                            || error.response.data.error
                            || msg;
                    } else if (error.message) {
                        msg = error.message;
                    }
                    notify(msg, 'error', 4000);
                    console.error(error);
                });
        },
        onSelectionChanged(e) {
            const row = e.selectedRowsData?.[0]
            if (!row) return

            const empId =
                row.employeeId ||
                row.EmployeeId ||
                row.ID ||
                row.Id ||
                null

            this.lastEmpId = empId

            this.$emit('selection-changed', {
                empId,
                mode: this.modPreluare
            })

        },
        onModeChanged(e) {
            this.$emit('selection-changed', {
                empId: this.lastEmpId || null,
                mode: this.modPreluare
            })
        },
        calculateFullName(rowData) {
            return `${rowData.Name} ${rowData.Surname}`;
        },
        calculateFilterExpression(value, operation) {
            return [
                ["Name", operation, value],
                "or",
                ["Surname", operation, value]
            ];
        },
        getDepartamente() {
            PER_ActiveEmployees
                .getDepartamente()
                .then((response: any) => {
                    this.dsDepartamente = response.data;
                })
                .catch((e: Error) => console.log(e));
        },
        onAddClick() {
            this.addPopupVisible = true
        },
        submitForm() {
            if (!this.formData.Name || this.formData.Name.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
                return;
            }
            if (!this.formData.Surname || this.formData.Surname.trim() === '') {
                notify('Completați câmpul obligatoriu "Prenume"!', 'error', 1000);
                return;
            }
            if (!this.formData.Cnp || this.formData.Cnp.trim() === '') {
                notify('Completați câmpul obligatoriu "CNP"!', 'error', 1000);
                return;
            }
            if (!this.formData.EmpgroupId) {
                notify('Completați câmpul obligatoriu "Grup Angajati"!', 'error', 1000);
                return;
            }
            if (!this.formData.StructId || this.formData.StructId.trim() === '') {
                notify('Completați câmpul obligatoriu "Departament"!', 'error', 1000);
                return;
            }

            const body = { ...this.formData };
            console.log('payload:', JSON.stringify(body));

            PER_Employees.save(body)
                .then(() => {
                    this.addPopupVisible = false;
                    this.onRefreshClick();

                    notify('Angajatul a fost salvat cu succes.', 'success', 3000);
                })
                .catch((error) => {
                    let msg = 'A apărut o eroare la salvare.';

                    if (error.response && error.response.data) {
                        msg = error.response.data.message
                            || error.response.data.error
                            || msg;
                    } else if (error.message) {
                        msg = error.message;
                    }

                    notify(msg, 'error', 4000);
                    console.error(error);
                });
                
        },
        closePopup(): void {
            this.addPopupVisible = false;
        },
        closePopupAdrese(): void{
            this.popupAdreseVisible = false;
        },
        onRefreshClick() {
            const gridInstance = this.dataGridRef?.instance;
            if (gridInstance) {
                gridInstance.refresh();

            }
        },
        onCnpChanged(e: any) {
            const cnp = e.value as string;

            this.formData.Cnp = cnp;

            if (!cnp || cnp.length < 13) {
                this.isCnpValid = false;
                this.formData.Sex = null;
                this.formData.BornDate = null;
                this.formData.DepartmentId = null;
                return;
            }

            const valid = this.isValidCnp(cnp);
            this.isCnpValid = valid;

            if (!valid) {
                notify("CNP introdus este incorect.", "error", 3000);

                this.formData.Sex = null;
                this.formData.BornDate = null;
                this.formData.DepartmentId = null;

                return;
            }

            const s = parseInt(cnp[0], 10);
            const yy = cnp.substring(1, 3);
            const mm = cnp.substring(3, 5);
            const dd = cnp.substring(5, 7);

            let yearPrefix = "";
            if (s === 1 || s === 2) yearPrefix = "19";
            else if (s === 3 || s === 4) yearPrefix = "18";
            else if (s === 5 || s === 6) yearPrefix = "20";
            else if (s === 7 || s === 8) yearPrefix = "20";

            const fullYear = parseInt(yearPrefix + yy, 10);
            const birthDate = new Date(fullYear, parseInt(mm, 10) - 1, parseInt(dd, 10), 12, 0, 0);
            this.formData.BornDate = birthDate;


            const sexValue = (s % 2 === 1) ? "M" : "F";

            this.formData.Sex = sexValue;
            //this.formData.BornDate = birthDate;
        },

        isValidCnp(cnp: string): boolean {
            if (!cnp || cnp.length !== 13) return false;
            if (!/^\d{13}$/.test(cnp)) return false;

            const s = parseInt(cnp[0], 10);
            if (s < 1 || s > 8) return false;

            const yy = parseInt(cnp.substring(1, 3), 10);
            const mm = parseInt(cnp.substring(3, 5), 10);
            const dd = parseInt(cnp.substring(5, 7), 10);

            let yearPrefix = "";
            if (s === 1 || s === 2) yearPrefix = "19";
            else if (s === 3 || s === 4) yearPrefix = "18";
            else if (s === 5 || s === 6) yearPrefix = "20";
            else if (s === 7 || s === 8) yearPrefix = "20";

            const fullYear = parseInt(yearPrefix + yy.toString().padStart(2, "0"), 10);

            const birthDate = new Date(fullYear, mm - 1, dd);

            if (
                birthDate.getFullYear() !== fullYear ||
                birthDate.getMonth() !== mm - 1 ||
                birthDate.getDate() !== dd
            ) {
                return false;
            }

            const today = new Date();
            if (birthDate > today) return false;

            const weights = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
            let sum = 0;

            for (let i = 0; i < 12; i++) {
                sum += parseInt(cnp[i], 10) * weights[i];
            }

            let control = sum % 11;
            if (control === 10) control = 1;

            const lastDigit = parseInt(cnp[12], 10);

            return control === lastDigit;
        },
        onInitNewRow(e) {

            e.data.DocIdentTip = 'CarteIdentitate'
            e.data.FunctieDeBaza = true
            e.data.OreContract = 8
            e.data.ZileConc = 20
            e.data.D112TipAsigurat = '1'
            e.data.TaraNationalitateId = '0a2ed359-3731-47a2-855b-9ee58b1cbc32'

        },
        onTaraChanged(e) {
            this.taraId = e.value;
            this.dataAdress.TaraID = e.value;
            this.judetId = null;
            this.localitateId = null;
            this.satId = null;
            this.codSiruta = null;

            this.dsJudete.filter(["TaraID", "=", this.taraId]);
            this.dsJudete.load();
        }
        ,
        onJudetChanged(e) {
            this.judetId = e.value;
            this.dataAdress.JudetID = e.value;
            this.localitateId = null;
            this.satId = null;
            this.codSiruta = null;

            this.dsLocalitati.filter(["JudetID", "=", this.judetId]);
            this.dsLocalitati.load();
        },


        onLocalitateChanged(e) {
            this.localitateId = e.value;
            this.dataAdress.LocalitateID = e.value;
            this.satId = null;

            this.dsLocalitati.filter(["JudetID", "=", this.judetId]);
            this.dsLocalitati.load();
        },

        onSatChanged(e) {
            this.satId = e.value;

            if (!e.value || !this.dsLocalitati) return;

            const items = this.dsLocalitati.items ? this.dsLocalitati.items() : [];

            const satRow = items.find(x => x.ID === e.value);
            if (satRow) {
                this.codSiruta = satRow.CodSiruta;
                this.dataAdress.LocalitateCodSiruta = satRow.CodSiruta;
            }
        }

    }
});
</script>

<style scoped>
:deep(.tabs-two-rows .dx-tabs-wrapper) {
    flex-wrap: wrap;
}


:deep(.tabs-two-rows .dx-tab:nth-child(9)) {
    flex-basis: 25%;
    max-width: 25%;
}

:deep(.tabs-two-rows .dx-tab:nth-child(10)) {
    flex-basis: 30%;
    max-width: 30%;
}

:deep(.tabs-two-rows .dx-tab:nth-child(11)) {
    flex-basis: 50%;
    max-width: 50%;
}

:deep(.tabs-two-rows .dx-tab.dx-tab-selected) {
    background-color: #ff2c21;
    color: #ffffff;
}

:deep(.tabs-two-rows .dx-tab.dx-tab-selected .dx-tab-text) {
    color: inherit;
}


.disabled-grid {
    pointer-events: none;
    /* blochează interacțiunea */
    opacity: 0.5;
    /* face gri vizual */
    filter: grayscale(70%);
}

.salarii-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    padding: 10px;
    background: #f2f4f7;
    border: 1px solid #c7cdd5;
    font-size: 13px;
}

.salarii-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin: 10px 0;
    /* 20px sus și jos, 0 stânga-dreapta */
}

.left-block {
    display: flex;
    align-items: center;
    gap: 8px;
}

.act-btns {
    display: flex;
    gap: 30px;
    margin: 0 0;
    /* 20px sus și jos, 0 stânga-dreapta */
}

.salarii-grid {
    flex: 1;
    width: 100%;
    border: 1px solid #9db0d4;
    box-sizing: border-box;
}

/* header albastru */
.salarii-grid .dx-datagrid-headers {
    background: #3b5485;
    color: #fff;
    font-weight: 600;
    border-bottom: 1px solid #2f446a;
}

/* alternanta */
.salarii-grid .dx-row-alt {
    background: #f6f8fb;
}


/* rand filtru */
.salarii-grid .dx-datagrid-filter-row td {
    background: #dfe4ee;
    border-bottom: 1px solid #c6cfde;
}

.salarii-grid .dx-datagrid-filter-row .dx-editor-with-menu .dx-texteditor-input {
    height: 26px;
    font-size: 12px;
}

/* celule compacte */
.salarii-grid .dx-data-row td {
    padding: 4px 6px;
    font-size: 13px;
}

/* iconite albe in header */
.salarii-grid .dx-datagrid-headers .dx-sort,
.salarii-grid .dx-datagrid-headers .dx-header-filter {
    color: #fff;
}

:deep(.dx-switch) {
    pointer-events: auto;
}

.dx-switch-wrapper,
.dx-field-item-content {
    pointer-events: none;
}

.dx-switch * {
    pointer-events: auto;
}
</style>
